<template>
  <div>
    <!--    {{ storeId }}-->
    <div class="flex flex_gap_5 flex-wrap store_blocks mb-1">
      <div v-html="getStoreInfoByStore(storeId)"/>
      <template v-for="s in stores">
        <div v-html="getStoreInfoByStore(s)"/>
      </template>
    </div>
    <!--    {{ stores }}-->
  </div>
</template>

<script>

import moment from 'moment'

export default {
  props: ['drug', 'storeId', 'storeData'],
  data() {
    return {
      stores: [],
      updatedStoreData: {},
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  watch: {
    storeId: {
      handler: function (val, oldVal) {
        this.stores = this.getRelatedRequestsByStoreId(this.storeId);
      }
    }
  },
  created() {
    this.actualStoreData();
    this.stores = this.getRelatedRequestsByStoreId(this.storeId);
  },
  methods: {
    getStoreInfoByStore(storeId, numberOnly = false) {
      // console.log(storeId, exclude, numberOnly);
      if (!storeId) {
        storeId = this.actualStoreId;
      }
      if (!storeId) return;
      if (!this.updatedStoreData?.clearedStore) return;
      const stores = this.getRelatedRequestsByStoreId(storeId)
      // console.log(storeId, exclude, stores)

      const clearedStore = {...this.updatedStoreData.clearedStore};
      // console.log(clearedStore);
      Object.keys(this.updatedStoreData.storesRequests).forEach((sId) => {
        if (this.updatedStoreData.storesRequests[sId] <= 0) return;
        const store = this.$AllStores[sId];
        if (!clearedStore[store.parent_id]) clearedStore[store.parent_id] = 0;
        clearedStore[store.parent_id] -= this.updatedStoreData.storesRequests[sId];
      });

      // let qty = (this.updatedStoreData.clearedStore[storeId] || 0) - (this.updatedStoreData.storesRequests[storeId] || 0)
      let qty = (clearedStore?.[storeId] ?? 0);
      // console.log(stores, qty, storeId, this.updatedStoreData.clearedStore[storeId]);
      // stores.forEach((sId) => {
      //   qty -= +(this.updatedStoreData.storesRequests[sId] || 0)
      // })
      // console.log(qty);
      let transitQty = 0
      let transitDate = moment()
      if (this.storeData.transitDetails?.[this.drug.id]?.[storeId]?.details_in) {
        this.storeData.transitDetails[this.drug.id][storeId].details_in.forEach((t) => {
          transitQty += t.qty
          if (transitDate < moment(t.date)) {
            transitDate = moment(t.date)
          }
        })
      }
      let inStore = this.updatedStoreData.inStore && this.updatedStoreData.inStore[storeId] || 0
      inStore -= Object.keys(this.storeData.requests[this.drug.id] && this.storeData.requests[this.drug.id][storeId] || {}).reduce((acc, reserveType) => {
        acc += +this.storeData.requests[this.drug.id][storeId][reserveType].qty
        return acc
      }, 0)
      if (numberOnly) return qty;
      return (this.$AllStores[storeId] && this.$AllStores[storeId].short_title || `Не найден (${storeId})`) + ': <strong>' + (qty) + '</strong>'
        + (transitQty ? ` из них на складе <strong>${inStore}</strong> в дороге <strong>${transitQty}</strong> (поступление ${transitDate.format('DD.MM')})` : '')
    },
    actualStoreData() {
      const updatedStoreData = {
        inStore: this.storeData.actualStoreData[this.drug.id],
        clearedStore: {},
        storesRequests: {},
        relatedRequests: {},
      }
      Object.keys(this.storeData.transitDetails[this.drug.id] || {}).forEach((storeId) => {
        if (this.storeData.transitDetails[this.drug.id][storeId].out) {
          if (!updatedStoreData.inStore[storeId]) {
            updatedStoreData.inStore[storeId] = 0
          }
          updatedStoreData.inStore[storeId] -= this.storeData.transitDetails[this.drug.id][storeId].out
        }
      })

      Object.keys(this.$AllStores).forEach((sId) => {
        let re = (updatedStoreData.inStore && updatedStoreData.inStore[sId] || 0)
        Object.values(this.storeData.requests[this.drug.id] && this.storeData.requests[this.drug.id][sId] || {}).forEach((rr) => {
          Object.keys(rr.ordersQty).forEach((oId) => {
            if (this.$editNewOrder?.id !== +oId) {
              re -= +rr.ordersQty[oId]
              // re -= rr.qty;
            }
          })
        })

        if (this.storeData.transitDetails?.[this.drug.id]?.[sId]?.in) {
          re += this.storeData.transitDetails[this.drug.id][sId].in
        }

        if (re < 0) {
          updatedStoreData.clearedStore[sId] = 0
          updatedStoreData.storesRequests[sId] = Math.abs(re)
        } else {
          updatedStoreData.clearedStore[sId] = re
        }
      })
      this.updatedStoreData = updatedStoreData
    },
    getRelatedRequestsByStoreId(storeId, sortedStores = []) {
      const store = Object.values(this.$AllStores).find((s) => s.id === +storeId);
      if (store?.parent_id) {
        sortedStores.push(store.parent_id);
        sortedStores = this.getRelatedRequestsByStoreId(store.parent_id, sortedStores)
      }
      return sortedStores;
    }
  }

}

</script>

<style scoped>
.store_blocks div {
  border: 2px solid #bbbbbb;
  padding: 3px;
}
</style>
